module.exports = __webpack_public_path__ + "static/img/YM.4fe571d3.jpg";